<script>
    import PreviewElement from "./PreviewElement";
    import ContactFormWrapperElement from "../../components/pagesbuilder/elements/ContactFormWrapperElement";

    export default {
        name: "PreviewContactFormWrapperElement",
        mixins: [
            PreviewElement,
            ContactFormWrapperElement
        ]
    }
</script>